<template lang="pug">
  section
    b-container
      h1 ORDERS
      //- b-form-group(label="SHOW")
        b-form-checkbox-group(:options="statusOptions", v-model="filter.status", switches, @input="getOrderLines()")
      content-loader(:height="7", v-if="alert.loading")
      div(v-else-if="orderLines && orderLines.length > 0")
        b-card.table-card
          p(v-if='orderLines.length < 1') No orderLines
          b-table(v-else="", :items="orderLines", :fields="fields", @row-clicked="item=>$set(item, '_showDetails', !item._showDetails)" sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless, hover)
            template(v-slot:cell(compOrder)="row") {{ row.item.customer_order_id }}
            template(v-slot:cell(compType)="row")
              b-badge() {{ row.item.type.toUpperCase() }}
            template(v-slot:cell(compQuantity)="row") {{ `${row.item.quantity} ${row.item.is_rental?' months':''}` }}
            template(v-slot:cell(compTotal)="row") {{ formatRands(row.item.line_total - row.item.commission) }}
            template(v-slot:cell(compPayout)="row")
              span(v-if="row.item.payout_id")
                router-link(:to="{ name: 'PayoutHistory', params: { payoutId: row.item.payout_id } }")
                  font-awesome-icon.mr-2(icon="check")
              span(v-else="") Pending
            template(v-slot:cell(compStatus)="row")
              b-badge(:variant="row.item.order_status==='completed'?'dark':'light'") {{ row.item.status.toUpperCase() }}
            //template(v-slot:row-details='row')
              b-container
                h6 Details
                ul.list-unstyled
                  li.my-1
                    small.text-muted Unit Price
                    span.ml-1 {{ formatRandsCents(row.item.line_total) }}
                  li.my-1
                    small.text-muted VAT
                    span.ml-1 {{ formatRandsCents(row.item.vat_amount) }}
                  li.my-1
                    small.text-muted Unit Discount
                    span.ml-1 {{ formatRandsCents(row.item.unit_discount) }}
                  li.my-1
                    small.text-muted Quantity
                    span.ml-1 {{ `${row.item.quantity} ${row.item.is_rental?' months':''}` }}
                  li.my-1
                    span.font-weight-bold TOTAL
                    span.ml-1 {{ formatRandsCents(row.item.line_total) }}
      nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Payout',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      orderLines: [],
      statusOptions: ['active', 'completed'],
      filter: {
        status: [],
      },
      currentPage: 1,
      fields: [
        { key: 'compOrder', label: 'Order#' },
        { key: 'title', label: 'Piece' },
        { key: 'compType', label: 'Type' },
        { key: 'compQuantity', label: 'Quantity' },
        { key: 'compTotal', label: 'To Artist' },
        { key: 'compPayout', label: 'Payout' },
        { key: 'compStatus', label: 'Status' },

      ],
    };
  },
  computed: {
    totalRows() {
      return this.orderLines.length;
    },
  },
  methods: {
    async getOrderLines() {
      try {
        this.loading();
        this.orderLines = await apiService.getOrderLines(this.filter);
        this.clear();
      } catch (error) {
        this.error('Could not fetch items');
      }
    },
  },
  async created() {
    this.getOrderLines();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Orders.vue